<template>
  <!-- eslint-disable -->
	<v-container fluid>
		<v-slide-y-transition mode="out-in">
			<div>
        <h2 style="padding-bottom: 25px;">Weekly P&L Input</h2>
				<v-speed-dial v-model="fab" right top fixed direction="bottom" transition="slide-y-reverse-transition" >
          <template v-slot:activator>
            <v-btn class="refresh-btn" v-model="fab" color="blue darken-2" dark fab>
              <v-icon v-if="fab">close</v-icon>
              <v-icon v-else>account_circle</v-icon>
            </v-btn>
          </template>
					<v-btn fab dark small color="red" class="refresh-fixed-cost-btn" @click="load()">
						<v-icon>refresh</v-icon>
					</v-btn>
				</v-speed-dial>
        <v-btn v-if="currentTab == 0" @click="addFixedCostItem()" color="primary" style="position: absolute; top: 25px; right: 25px;" dark class="add-fixed-costs-btn mb-2">Add</v-btn>
        <v-btn v-if="currentTab == 1" @click="editCourierCOG()" color="indigo" style="position: absolute; top: 25px; right: 25px;" dark class="add-fixed-costs-btn mb-2">Add</v-btn>
        <v-btn v-if="currentTab == 2" @click="editBudget()" color="indigo" style="position: absolute; top: 25px; right: 25px;" dark class="add-fixed-costs-btn mb-2">Add</v-btn>
				<v-dialog v-model="editFixedCostDialog" max-width="500px">
					<v-card>
						<v-form v-model="fixedCostItemValid" ref="form" lazy-validation>
							<v-card-title>
								<span class="headline">{{ formTitle }}</span>
							</v-card-title>
							<v-card-text style="padding-top: 0;">
								<v-container grid-list-md style="padding-top: 0;">
									<v-layout row wrap>
										<v-flex xs12 id="time-picker-menu">
                      <v-menu ref="fixedCostItemMenuTimePicker" :close-on-content-click="false" v-model="fixedCostItemMenuTimePicker" :nudge-right="40" transition="scale-transition" offset-y  max-width="290px" min-width="290px" >
												<template v-slot:activator="{ on }">
                          <v-text-field id="time-picker-text" v-on="on" v-model="editedItem.WeekEnding" :rules="[rulesRequired]" label="Week Ending" hint="YYYY-MM-DD format" persistent-hint prepend-icon="event" readonly ></v-text-field>
												</template>
                        <v-date-picker id="time-picker-calendar" :allowed-dates="allowedDates" v-model="editedItem.WeekEnding" no-title @input="fixedCostItemMenuTimePicker = false" ></v-date-picker>
											</v-menu>
										</v-flex>
										<v-flex xs12 class="cost-input">
											<v-text-field :validate-on-blur="true" label="Cost" type="number" v-model.number="editedItem.Cost" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
										</v-flex>
                    <v-flex xs12>
											<v-text-field :validate-on-blur="true" class="labor-input" label="Avg Labor Cost/Hour" type="number" v-model.number="editedItem.AvgLaborCostPerHour" persistent-hint :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
										</v-flex>
                    <v-flex xs12>
											<v-text-field :validate-on-blur="true" class="Shrinkage-input" label="Shrinkage" v-model.number="editedItem.Shrinkage" hint="Enter Shrinkage to 3 decimal places. (0.123)" persistent-hint type="number" :rules="[rulesRequired, rulesProperDecimal, rules3DecimalPlaces]" prepend-icon="unfold_less" ></v-text-field>
										</v-flex>
                    <v-flex xs12>
											<v-text-field :validate-on-blur="true" label="Box Revenue" type="number" v-model.number="editedItem.BoxRevenue" :rules="[rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
										</v-flex>
                    <v-flex xs12>
											<v-text-field :validate-on-blur="true" label="Box Costs" type="number" v-model.number="editedItem.BoxCost" :rules="[rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
										</v-flex>
                    <v-flex xs12>
											<v-text-field :validate-on-blur="true" label="Technology Costs" type="number" v-model.number="editedItem.TechnologyCost" :rules="[rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
										</v-flex>
                    <v-flex xs12>
											<v-text-field :validate-on-blur="true" label="Implementation Fees" type="number" v-model.number="editedItem.ImplementationFee" :rules="[rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
										</v-flex>
									</v-layout>
								</v-container>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="blue darken-1" class="cancel-add-btn" text @click="closeEditDialog">Cancel</v-btn>
								<v-btn color="blue darken-1" :disabled="!fixedCostItemValid" class="save-btn" text @click="saveFixedCostItems">Save</v-btn>
							</v-card-actions>
						</v-form>
					</v-card>
				</v-dialog>
        <v-dialog v-model="editCourierCOGDialog" max-width="500px">
					<v-card>
						<v-form v-model="courierCOGValid" ref="courierCOGForm" lazy-validation>
							<v-card-title>
								<span class="headline">Courier Cost of Goods Percentage</span>
							</v-card-title>
							<v-card-text style="padding-top: 0;">
								<v-container grid-list-md  style="padding-top: 0;">
									<v-layout row wrap>
										<v-flex xs12>
											<v-menu :disabled="courierCOGMonthSelect" ref="courierCOGMenuTimePicker" :close-on-content-click="false" v-model="courierCOGMenuTimePicker" :nudge-right="40"  transition="scale-transition" offset-y id="time-picker-menu" max-width="290px" min-width="290px" >
												<template v-slot:activator="{ on }">
                          <v-text-field :disabled="courierCOGMonthSelect" id="time-picker-text" v-on="on" v-model="courierCOGEditItem.MonthYear" :rules="[rulesRequired, rulesNoDuplicateMonth]" label="Month" hint="YYYY-MM format" persistent-hint prepend-icon="event" readonly ></v-text-field>
												</template>
                        <v-date-picker :disabled="courierCOGMonthSelect" id="time-picker-calendar" v-model="courierCOGEditItem.MonthYear" type="month" no-title @input="courierCOGMenuTimePicker = false" ></v-date-picker>
											</v-menu>
										</v-flex>
                    <v-flex xs12>
											<v-text-field :validate-on-blur="true" class="estimated-cost-input" label="Estimated Cost" v-model.number="courierCOGEditItem.EstimatedCostPercentage" hint="Enter Estimated Cost Percentage to 3 decimal places. (0.123)" persistent-hint type="number" :rules="[rulesRequired, rules3DecimalPlaces]" prepend-icon="show_chart" ></v-text-field>
										</v-flex>
                    <v-flex xs12>
											<v-text-field :validate-on-blur="true" class="estimated-cost-input" label="Courier Adjustment" v-model.number="courierCOGEditItem.CourierAdjustmentPercentage" hint="Enter Estimated Courier Adjustment Percentage to 3 decimal places. (0.123)" persistent-hint type="number" :rules="[rulesRequired, rules3DecimalPlaces]" prepend-icon="local_shipping" ></v-text-field>
										</v-flex>
                    <v-flex xs12>
											<v-text-field :validate-on-blur="true" class="estimated-cost-input" label="Shipping Days" v-model.number="courierCOGEditItem.ShippingDays" hint="Enter Number of Shipping days for this month" persistent-hint type="number" :rules="[rulesRequired, rulesInteger]" prepend-icon="local_shipping" ></v-text-field>
										</v-flex>
									</v-layout>
								</v-container>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="blue darken-1" class="cancel-add-btn" text @click="editCourierCOGDialog = false">Cancel</v-btn>
								<v-btn color="blue darken-1" class="save-btn" :disabled="!courierCOGValid" text @click="saveCourierCOG">Save</v-btn>
							</v-card-actions>
						</v-form>
					</v-card>
				</v-dialog>
        <v-dialog v-model="editBudgetDialog" max-width="1000px">
          <v-card>
            <v-card-title>
              <span class="headline">Budget</span>
            </v-card-title>
            <v-container grid-list-md class="pa-3">
              <v-flex xs12>
                <v-switch
                  id="switchVolumes"
                  label="CaptureVolumes"
                  v-model="isSwitchVolumeSelected"
                ></v-switch>
              </v-flex xs12>
            </v-container>
            <v-form v-model="budgetValid" ref="budgetForm" lazy-validation>
              <v-card-text class="pa-3">
                <v-container grid-list-md class="pa-3">
                  <v-layout row wrap>
                    <v-flex xs12 id="time-picker-menu">
                      <v-menu ref="budgetItemMenuTimePicker" :close-on-content-click="false" v-model="budgetItemMenuTimePicker" :nudge-right="40" transition="scale-transition" offset-y  max-width="290px" min-width="290px" >
												<template v-slot:activator="{ on }">
                          <v-text-field id="time-picker-text" v-on="on" v-model="budgetItem.WeekEnding" :rules="[rulesRequired]" label="Week Ending" hint="YYYY-MM-DD format" persistent-hint prepend-icon="event" readonly ></v-text-field>
												</template>
                        <v-date-picker id="time-picker-calendar" :allowed-dates="allowedDates" v-model="budgetItem.WeekEnding" no-title @input="budgetItemMenuTimePicker = false" ></v-date-picker>
											</v-menu>
										</v-flex>
                    <v-flex xs12 class="days-input">
											<v-text-field :validate-on-blur="true" id="weekly-shipping-days" label="Shipping Days" type="number" v-model.number="budgetItem.ShippingDays" :rules="[rulesRequired, rulesInteger]" prepend-icon="local_shipping" ></v-text-field>
										</v-flex>
                    
                    <v-layout row wrap v-if="!isSwitchVolumeSelected">
                      <v-flex xs6>
                        <v-card-subtitle>
                        <span>Protector</span>
                        </v-card-subtitle>
                        <v-text-field :validate-on-blur="true" id="protector-Budget-input" class="Budget-input" label="Budget" v-model.number="budgetItem.ProtectorBudget" persistent-hint type="number" :rules="[ rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="protector-ThreePlusNine-input" class="ThreePlusNine-input" label="3+9" v-model.number="budgetItem.ProtectorThreePlusNine" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="protector-SixPlusSix-input" class="SixPlusSix-input" label="6+6" v-model.number="budgetItem.ProtectorSixPlusSix" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="protector-NinePlusThree-input" class="NinePlusThree-input" label="9+3" v-model.number="budgetItem.ProtectorNinePlusThree" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-card-subtitle>
                        <span>Tracker</span>
                        </v-card-subtitle>
                        <v-text-field :validate-on-blur="true" id="tracker-Budget-input" class="Budget-input" label="Budget" v-model.number="budgetItem.TrackerBudget" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="tracker-ThreePlusNine-input" class="ThreePlusNine-input" label="3+9" v-model.number="budgetItem.TrackerThreePlusNine" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="tracker-SixPlusSix-input" class="SixPlusSix-input" label="6+6" v-model.number="budgetItem.TrackerSixPlusSix" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="tracker-NinePlusThree-input" class="NinePlusThree-input" label="9+3" v-model.number="budgetItem.TrackerNinePlusThree" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-card-subtitle>
                        <span>T1</span>
                        </v-card-subtitle>
                        <v-text-field :validate-on-blur="true" id="t1-Budget-input" class="Budget-input" label="Budget" v-model.number="budgetItem.T1Budget" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t1-ThreePlusNine-input" class="ThreePlusNine-input" label="3+9" v-model.number="budgetItem.T1ThreePlusNine" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t1-SixPlusSix-input" class="SixPlusSix-input" label="6+6" v-model.number="budgetItem.T1SixPlusSix" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t1-NinePlusThree-input" class="NinePlusThree-input" label="9+3" v-model.number="budgetItem.T1NinePlusThree" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-card-subtitle>
                        <span>T2</span>
                        </v-card-subtitle>
                        <v-text-field :validate-on-blur="true" id="t2-Budget-input" class="Budget-input" label="Budget" v-model.number="budgetItem.T2Budget" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t2-ThreePlusNine-input" class="ThreePlusNine-input" label="3+9" v-model.number="budgetItem.T2ThreePlusNine" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t2-SixPlusSix-input" class="SixPlusSix-input" label="6+6" v-model.number="budgetItem.T2SixPlusSix" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t2-NinePlusThree-input" class="NinePlusThree-input" label="9+3" v-model.number="budgetItem.T2NinePlusThree" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]" prepend-icon="attach_money" ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="isSwitchVolumeSelected">
                      <v-flex xs6>
                        <v-card-subtitle>
                        <span>Protector</span>
                        </v-card-subtitle>
                        <v-text-field :validate-on-blur="true" id="protector-Budget-volume-input" class="Budget-input" label="Volume" v-model.number="budgetItem.ProtectorBudgetVolume" persistent-hint type="number" :rules="[ rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="protector-ThreePlusNine-volume-input" class="ThreePlusNine-input" label="3+9" v-model.number="budgetItem.ProtectorThreePlusNineVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="protector-SixPlusSix-volume-input" class="SixPlusSix-input" label="6+6" v-model.number="budgetItem.ProtectorSixPlusSixVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="protector-NinePlusThree-volume-input" class="NinePlusThree-input" label="9+3" v-model.number="budgetItem.ProtectorNinePlusThreeVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-card-subtitle>
                        <span>Tracker</span>
                        </v-card-subtitle>
                        <v-text-field :validate-on-blur="true" id="tracker-Budget-volume-input" class="Budget-input" label="Volume" v-model.number="budgetItem.TrackerBudgetVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="tracker-ThreePlusNine-volume-input" class="ThreePlusNine-input" label="3+9" v-model.number="budgetItem.TrackerThreePlusNineVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="tracker-SixPlusSix-volume-input" class="SixPlusSix-input" label="6+6" v-model.number="budgetItem.TrackerSixPlusSixVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="tracker-NinePlusThree-volume-input" class="NinePlusThree-input" label="9+3" v-model.number="budgetItem.TrackerNinePlusThreeVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-card-subtitle>
                        <span>T1</span>
                        </v-card-subtitle>
                        <v-text-field :validate-on-blur="true" id="t1-Budget-volume-input" class="Budget-input" label="Volume" v-model.number="budgetItem.T1BudgetVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t1-ThreePlusNine-volume-input" class="ThreePlusNine-input" label="3+9" v-model.number="budgetItem.T1ThreePlusNineVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t1-SixPlusSix-volume-input" class="SixPlusSix-input" label="6+6" v-model.number="budgetItem.T1SixPlusSixVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t1-NinePlusThree-volume-input" class="NinePlusThree-input" label="9+3" v-model.number="budgetItem.T1NinePlusThreeVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-card-subtitle>
                        <span>T2</span>
                        </v-card-subtitle>
                        <v-text-field :validate-on-blur="true" id="t2-Budget-volume-input" class="Budget-input" label="Volume" v-model.number="budgetItem.T2BudgetVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t2-ThreePlusNine-volume-input" class="ThreePlusNine-input" label="3+9" v-model.number="budgetItem.T2ThreePlusNineVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t2-SixPlusSix-volume-input" class="SixPlusSix-input" label="6+6" v-model.number="budgetItem.T2SixPlusSixVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                        <v-text-field :validate-on-blur="true" id="t2-NinePlusThree-volume-input" class="NinePlusThree-input" label="9+3" v-model.number="budgetItem.T2NinePlusThreeVolume" persistent-hint type="number" :rules="[rulesRequired, rulesCurrency]"  ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
					    	<v-btn color="blue darken-1" class="cancel-add-btn" text @click="closeBudgetDialog">Cancel</v-btn>
					    	<v-btn color="blue darken-1" class="save-btn" :disabled="false" text @click="saveBudgetItems">Save</v-btn>
					    </v-card-actions>
            </v-form>            
          </v-card>
        </v-dialog>
        <v-dialog v-model="deleteFixedCostDialog" max-width="400px">
					<v-card>
            <div style="text-align: center; padding: 25px;">
              <h3>Are you sure you want to delete this item?</h3>
              <v-btn class="confirm-delete" @click="deleteFixedCostItem" color="red"><v-icon>delete</v-icon> Delete</v-btn>
              <v-btn @click="closeDeleteFixedItemDialog"><v-icon>close</v-icon> Cancel</v-btn>
            </div>
					</v-card>
				</v-dialog>
        <v-dialog v-model="deleteCourierCOGDialog" max-width="400px">
					<v-card>
            <div style="text-align: center; padding: 25px;">
              <h3>Are you sure you want to delete this item?</h3>
              <v-btn class="confirm-delete" @click="deleteCourierCOG" color="red"><v-icon>delete</v-icon> Delete</v-btn>
              <v-btn @click="closeDeleteCourierCOGDialog"><v-icon>close</v-icon> Cancel</v-btn>
            </div>
					</v-card>
				</v-dialog>
        <v-dialog v-model="deleteBudgetDialog" max-width="400px">
          <v-card>
            <div style="text-align: center; padding: 25px;">
              <h3>Are you sure you want to delete this item?</h3>
              <v-btn class="confirm-delete" @click="deleteBudgetItem" color="red"><v-icon>delete</v-icon> Delete</v-btn>
              <v-btn @click="closeDeleteBudgetDialog"><v-icon>close</v-icon> Cancel</v-btn>
            </div>
					</v-card>
        </v-dialog>
        <v-tabs v-model="currentTab" :touchless="true" slider-color="black" >
          <v-tab v-for="tab in tabData" :key="tab.key" ripple :class="tab.key" >{{tab.label}}</v-tab>
        </v-tabs>
				<v-data-table :mobile-breakpoint="0" class="fixed-costs-data-table" v-show="currentTab === 0" disable-pagination hide-default-footer :items="fixedCosts" item-key="Id"	:headers="fixedCostItemHeaders" :loading="loading" :sort-by.sync="fixedCostSortBy" :sort-desc.sync="budgetDescending" >
					<template v-slot:item="{ item }" item-key="HashKey">
						<tr>
							<td>{{item.WeekEnding | formatWholeDate}}</td>
              <td>{{item.Shrinkage}}</td>
							<td><span v-if="item.Cost">${{item.Cost.toFixed(2)}}</span></td>
              <td><span v-if="item.AvgLaborCostPerHour">${{item.AvgLaborCostPerHour.toFixed(2)}}</span></td>
							<td>
								<v-icon small class="edit-fixed-costs-btn mr-2" @click="editFixedCostItem(item)">edit</v-icon>
								<v-icon small class="delete-fixed-costs-btn" @click="openDeleteFixedCostDialog(item.Id)">delete</v-icon>
							</td>
						</tr>
					</template>
					<template slot="no-data">
						<div v-if="loading" class="text-xs-center">Loading data. . .</div>
						<div v-else class="text-xs-center">No data entered</div>
					</template>
				</v-data-table>
        <v-data-table :mobile-breakpoint="0" class="cog-data-table" v-show="currentTab === 1" hide-default-footer :items="courierCOG" item-key="Id"	:headers="courierCOGHeaders" :loading="loading" :sort-by.sync="courierCOGSortBy" :sort-desc.sync="courierCOGDescending" >
					<template v-slot:item="{ item }" item-key="HashKey">
						<tr>
							<td>{{item.MonthYear | formatMonthDate}}</td>
              <td>{{item.EstimatedCostPercentage}}</td>
              <td>{{item.CourierAdjustmentPercentage}}</td>
              <td>{{item.ShippingDays}}</td>
              <td>
								<v-icon small class="edit-fixed-costs-btn mr-2" @click="editCourierCOG(item)">edit</v-icon>
								<v-icon small class="delete-fixed-costs-btn" @click="openDeleteCourierCOGDialog(item.MonthYear)">delete</v-icon>
							</td>
						</tr>
					</template>
				</v-data-table>
        <v-data-table :mobile-breakpoint="0" class="budget-data-table" v-show="currentTab === 2" disable-pagination hide-default-footer :items="budgets" item-key="Id"	:headers="budgetItemHeaders" :loading="loading" :sort-by.sync="budgetSortBy" :sort-desc.sync="budgetDescending" >
          <template v-slot:item="{ item }" item-key="HashKey">
            <tr>
              <td>{{item.WeekEnding | formatWholeDate}}</td>
              <td>{{item.ShippingDays}}</td>
              <td>
								<v-icon small class="edit-fixed-costs-btn mr-2" @click="editBudget(item)">edit</v-icon>
								<v-icon small class="delete-fixed-costs-btn" @click="openDeleteBudgetDialog(item.Id)">delete</v-icon>
							</td>
            </tr>
          </template>
        </v-data-table>
			</div>
		</v-slide-y-transition>
	</v-container>
<!-- eslint-enable -->
</template>
<script>
import fixedCostModule, { FIXED_COST_NAMESPACE } from "./store/fixedCostStore";
import moment from "moment";
import { mapGetters } from "vuex";
import RulesMixin from "@/mixins/RulesMixin.js";

export default {
  name: "FixedCost",
  mixins: [RulesMixin],
  data() {
    return {
      isSwitchVolumeSelected: false,
      courierCOGEditItem: {
        EstimatedCostPercentage: null,
        CourierAdjustmentPercentage: null,
        MonthYear: null,
        ShippingDays: null
      },
      courierCOGHeaders: [
        {
          text: "Month",
          sortable: true,
          align: "left",
          value: "MonthYear"
        },
        {
          text: "Estimated Cost Percentage",
          sortable: false,
          align: "left",
          value: "EstimatedCostPercentage"
        },
        {
          text: "Courier Adjustment Percentage",
          sortable: false,
          align: "left",
          value: "CourierAdjustmentPercentage"
        },
        {
          text: "Shipping Days",
          sortable: false,
          align: "left",
          value: "ShippingDays"
        },
        {
          text: "Actions",
          sortable: false,
          value: "Id"
        }
      ],
      courierCOGMenuTimePicker: false,
      courierCOGMonthSelect: false,
      courierCOGSortBy: "MonthYear",
      courierCOGDescending: true,
      courierCOGValid: false,
      currentTab: 0,
      defaultFixedCostItem: {
        Id: null,
        WeekEnding: null,
        Cost: null,
        Shrinkage: null,
        AvgLaborCostPerHour: null,
        Budget: null,
        ThreePlusNine: null,
        SixPlusSix: null,
        NinePlusThree: null,
        BoxRevenue: null,
        BoxCost: null,
        TechnologyCost: null,
        ImplementationFee: null
      },
      deleteCourierCOGDialog: false,
      deleteFixedCostDialog: false,
      deleteBudgetDialog: false,
      deleteId: null,
      deleteMonthYear: null,
      editCourierCOGDialog: false,
      editFixedCostDialog: false,
      editBudgetDialog: false,
      deleteBudgetId: null,
      editedItem: {
        Id: null,
        WeekEnding: null,
        Cost: null,
        Shrinkage: null,
        AvgLaborCostPerHour: null,
        BoxRevenue: null,
        BoxCost: null,
        TechnologyCost: null,
        ImplementationFee: null
      },
      budgetItem: {
        Id: null,
        WeekEnding: null,
        ShippingDays: null,
        ProtectorBudget: null,
        ProtectorThreePlusNine: null,
        ProtectorSixPlusSix: null,
        ProtectorNinePlusThree: null,
        TrackerBudget: null,
        TrackerThreePlusNine: null,
        TrackerSixPlusSix: null,
        TrackerNinePlusThree: null,
        T1Budget: null,
        T1ThreePlusNine: null,
        T1SixPlusSix: null,
        T1NinePlusThree: null,
        T2Budget: null,
        T2ThreePlusNine: null,
        T2SixPlusSix: null,
        T2NinePlusThree: null,

        ProtectorBudgetVolume: null,
        ProtectorThreePlusNineVolume: null,
        ProtectorSixPlusSixVolume: null,
        ProtectorNinePlusThreeVolume: null,
        TrackerBudgetVolume: null,
        TrackerThreePlusNineVolume: null,
        TrackerSixPlusSixVolume: null,
        TrackerNinePlusThreeVolume: null,
        T1BudgetVolume: null,
        T1ThreePlusNineVolume: null,
        T1SixPlusSixVolume: null,
        T1NinePlusThreeVolume: null,
        T2BudgetVolume: null,
        T2ThreePlusNineVolume: null,
        T2SixPlusSixVolume: null,
        T2NinePlusThreeVolume: null
      },
      fab: false,
      fixedCostItemHeaders: [
        {
          text: "Week Ending",
          sortable: true,
          align: "left",
          value: "WeekEnding"
        },
        {
          text: "Shrinkage",
          sortable: true,
          align: "left",
          value: "Shrinkage"
        },
        {
          text: "Total Fixed Cost",
          sortable: true,
          align: "left",
          value: "Cost"
        },
        {
          text: "Avg Labor Cost/ Hour",
          sortable: true,
          value: "AvgLaborCostPerHour"
        },
        {
          text: "Actions",
          sortable: false,
          value: "Id"
        }
      ],
      budgetItemHeaders: [
        {
          text: "Week Ending",
          sortable: true,
          align: "left",
          value: "WeekEnding"
        },
        {
          text: "Shipping Days",
          sortable: false,
          align: "left",
          value: "ShippingDays"
        },
        {
          text: "Actions",
          sortable: false,
          value: "Id"
        }
      ],
      fixedCostItemMenuTimePicker: false,
      fixedCostSortBy: "WeekEnding",
      fixedCostDescending: true,
      fixedCostItemValid: false,
      budgetItemMenuTimePicker: false,
      volumeItemMenuTimePicker: false,
      budgetSortBy: "WeekEnding",
      budgetDescending: true,
      budgetValid: false,
      volumeValid: false,
      tabData: [
        {
          key: "pAndL",
          label: "Weekly P&L"
        },
        {
          key: "courierCOG",
          label: "Courier Cost of Goods"
        },
        {
          key: "budget",
          label: "Budget"
        }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.editedItem.Id === null ? "New Item" : "Edit Item";
    },
    ...mapGetters(FIXED_COST_NAMESPACE, ["courierCOG", "fixedCosts", "budgets", "loading"])
  },
  created: function() {
    this.$registerVuexModule(FIXED_COST_NAMESPACE, fixedCostModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.BILLING_ADMIN]).then(
      res => {
        if (res) {
          this.load();
        } else this.$goHome();
      }
    );
  },
  methods: {
    addCourierCOG(itemDate) {
      var editItem = {
        CourierAdjustmentPercentage: null,
        EstimatedCostPercentage: null,
        MonthYear: itemDate.substring(0, 7),
        ShippingDays: null,
        IsNew: true
      };
      if (itemDate) this.courierCOGMonthSelect = true;

      this.editCourierCOG(editItem);
    },
    addFixedCostItem() {
      if (this.$refs.form) this.$refs.form.reset();
      this.editedItem = Object.assign({}, this.defaultFixedCostItem);
      this.editFixedCostDialog = true;
    },
    allowedDates(val) {
      return ![0, 1, 2, 3, 4, 5].includes(
        moment(val, "YYYY-MM-DD")
          .toDate()
          .getDay()
      );
    },
    closeDeleteCourierCOGDialog() {
      this.deleteCourierCOGDialog = false;
      this.deleteMonthYear = null;
    },
    closeDeleteFixedItemDialog() {
      this.deleteFixedCostDialog = false;
      this.deleteId = null;
    },
    closeDeleteBudgetDialog() {
      this.deleteBudgetDialog = false;
      this.deleteBudgetId = null;
    },
    closeEditDialog() {
      this.editFixedCostDialog = false;
    },
    closeBudgetDialog() {
      this.editBudgetDialog = false;
    },
    deleteCourierCOG() {
      return this.$store
        .dispatch(
          `${FIXED_COST_NAMESPACE}/deleteCourierCOG`,
          this.deleteMonthYear
        )
        .then(() => this.closeDeleteCourierCOGDialog());
    },
    deleteFixedCostItem() {
      return this.$store
        .dispatch(`${FIXED_COST_NAMESPACE}/deleteFixedCostItem`, this.deleteId)
        .then(() => this.closeDeleteFixedItemDialog());
    },
    deleteBudgetItem() {
      return this.$store
        .dispatch(`${FIXED_COST_NAMESPACE}/deleteBudgetItem`, this.deleteBudgetId)
        .then(() => this.closeDeleteBudgetDialog());
    },
    editCourierCOG(editItem) {
      if (!editItem) editItem = {};
      this.courierCOGEditItem = {
        CourierAdjustmentPercentage: editItem.CourierAdjustmentPercentage,
        EstimatedCostPercentage: editItem.EstimatedCostPercentage,
        MonthYear: this.formatMonthYear(editItem.MonthYear),
        SavedMonthYear: this.formatMonthYear(editItem.MonthYear),
        ShippingDays: editItem.ShippingDays
      };
      this.editCourierCOGDialog = true;
    },
    editBudget(item) {
      if (!item) item = {};
      this.budgetItem = {
        Id: item.Id,
        WeekEnding: item.WeekEnding,
        ShippingDays: item.ShippingDays,
        TrackerBudget: item.TrackerBudget,
        TrackerThreePlusNine: item.TrackerThreePlusNine,
        TrackerSixPlusSix: item.TrackerSixPlusSix,
        TrackerNinePlusThree: item.TrackerNinePlusThree,
        ProtectorBudget: item.ProtectorBudget,
        ProtectorThreePlusNine: item.ProtectorThreePlusNine,
        ProtectorSixPlusSix: item.ProtectorSixPlusSix,
        ProtectorNinePlusThree: item.ProtectorNinePlusThree,
        T1Budget: item.T1Budget,
        T1ThreePlusNine: item.T1ThreePlusNine,
        T1SixPlusSix: item.T1SixPlusSix,
        T1NinePlusThree: item.T1NinePlusThree,
        T2Budget: item.T2Budget,
        T2ThreePlusNine: item.T2ThreePlusNine,
        T2SixPlusSix: item.T2SixPlusSix,
        T2NinePlusThree: item.T2NinePlusThree,

        TrackerBudgetVolume: item.TrackerBudgetVolume,
        TrackerThreePlusNineVolume: item.TrackerThreePlusNineVolume,
        TrackerSixPlusSixVolume: item.TrackerSixPlusSixVolume,
        TrackerNinePlusThreeVolume: item.TrackerNinePlusThreeVolume,
        ProtectorBudgetVolume: item.ProtectorBudgetVolume,
        ProtectorThreePlusNineVolume: item.ProtectorThreePlusNineVolume,
        ProtectorSixPlusSixVolume: item.ProtectorSixPlusSixVolume,
        ProtectorNinePlusThreeVolume: item.ProtectorNinePlusThreeVolume,
        T1BudgetVolume: item.T1BudgetVolume,
        T1ThreePlusNineVolume: item.T1ThreePlusNineVolume,
        T1SixPlusSixVolume: item.T1SixPlusSixVolume,
        T1NinePlusThreeVolume: item.T1NinePlusThreeVolume,
        T2BudgetVolume: item.T2BudgetVolume,
        T2ThreePlusNineVolume: item.T2ThreePlusNineVolume,
        T2SixPlusSixVolume: item.T2SixPlusSixVolume,
        T2NinePlusThreeVolume: item.T2NinePlusThreeVolume
      };
      this.editBudgetDialog = true;
    },
    editFixedCostItem(item) {
      this.editedItem = Object.assign({}, item);
      this.editedItem.WeekEnding = moment(item.WeekEnding).format("YYYY-MM-DD");
      this.editFixedCostDialog = true;
    },
    formatMonthYear(monthYear) {
      if (monthYear) return monthYear.substring(0, 7);
    },
    getFixedCostCourierCog(fixedCost) {
      if (fixedCost.WeekEnding)
        this.courierCOG.forEach(x => {
          if (
            fixedCost.WeekEnding.substring(0, 7) === x.MonthYear.substring(0, 7)
          ) {
            fixedCost.CourierCOG = x.EstimatedCostPercentage;
            return x.EstimatedCostPercentage;
          }
        });
      return fixedCost.CourierCOG;
    },
    load() {
      this.loadCourierCOG();
      this.loadFixedCostItems();
      this.loadBudgetItems();
    },
    loadCourierCOG() {
      this.$store.dispatch(`${FIXED_COST_NAMESPACE}/loadCourierCOG`);
    },
    loadFixedCostItems() {
      return this.$store.dispatch(`${FIXED_COST_NAMESPACE}/loadFixedCostItems`);
    },
    loadBudgetItems() {
      return this.$store.dispatch(`${FIXED_COST_NAMESPACE}/loadBudgetItems`);
    },
    openDeleteCourierCOGDialog(monthYear) {
      this.deleteCourierCOGDialog = true;
      this.deleteMonthYear = monthYear;
      this.$refs.courierCOGForm.resetValidation();
    },
    openDeleteFixedCostDialog(id) {
      this.deleteFixedCostDialog = true;
      this.deleteId = id;
    },
    openDeleteBudgetDialog(id) {
      this.deleteBudgetDialog = true;
      this.deleteBudgetId = id;
    },
    rules3DecimalPlaces(v) {
      if (!v) return true;
      var numSplit = v.toString().split(".");
      if (
        numSplit.length === 2 &&
        numSplit[1].length > 0 &&
        numSplit[1].length < 5
      )
        return true;
      return "Must be 3 decimal places";
    },
    rulesNoDuplicateMonth(v) {
      var res = true;
      this.courierCOG.forEach(x => {
        if (
          x.MonthYear.substring(0, 7) === v &&
          this.courierCOGEditItem.SavedMonthYear !== v
        )
          res = "Data for this month has already exists.";
      });
      return res;
    },
    saveCourierCOG() {
      if (this.$refs.courierCOGForm.validate()) {
        this.courierCOGEditItem.MonthYear += "-01";
        this.$store
          .dispatch(
            `${FIXED_COST_NAMESPACE}/saveCourierCOG`,
            this.courierCOGEditItem
          )
          .then(() => {
            this.editCourierCOGDialog = false;
            this.$forceUpdate();
          });
      }
    },
    saveFixedCostItems() {
      if (this.$refs.form.validate()) {
        if (this.editedItem.Id != null) {
          var id = this.editedItem.Id;
          var found = _.find(this.fixedCosts, function(num) {
            return num.Id === id;
          });
          Object.assign(found, this.editedItem);
          this.$store.dispatch(
            `${FIXED_COST_NAMESPACE}/saveFixedCostItems`,
            this.editedItem
          );
        } else {
          this.editedItem.Id = 0;
          this.$store.dispatch(
            `${FIXED_COST_NAMESPACE}/saveFixedCostItems`,
            this.editedItem
          );
        }
        this.closeEditDialog();
      }
    },
    saveBudgetItems() {
      if (this.$refs.budgetForm.validate()) {
        if (this.budgetItem.Id != null) {
          var id = this.budgetItem.Id;
          var found = _.find(this.budgets, function(num) {
            return num.Id === id;
          });
          Object.assign(found, this.budgetItem);
          this.$store.dispatch(
            `${FIXED_COST_NAMESPACE}/saveBudgetItems`,
            this.budgetItem
          );
        } else {
          this.budgetItem.Id = 0;
          this.$store.dispatch(
            `${FIXED_COST_NAMESPACE}/saveBudgetItems`,
            this.budgetItem
          );
        }
        this.closeBudgetDialog();
      }
    }
  }
};
</script>
